import { Avatar, Box, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import * as Preact from 'preact';
import * as OriginalPrice from './A_OriginalPrice';

export interface Props {
    productThumbnail: string;
    productName: string;
    productPrice: number;
    productOriginalPrice: number;
    productCount: number;
}

export const Component = (p: Props) => {
    const showDiscount =
        p.productOriginalPrice * p.productCount - p.productPrice * p.productCount > 0;
    return (
        <>
            <ListItem
                key={p.productName}
                sx={{
                    padding: '24px',
                    minHeight: '75px',
                }}
            >
                <ListItemAvatar sx={{ paddingRight: '16px' }}>
                    <Avatar
                        variant="square"
                        src={p.productThumbnail}
                        sx={{
                            width: 75,
                            height: 75,
                            borderRadius: '4px',
                            outline: '1px solid #E0E0E0',
                            '.MuiAvatar-img': {
                                objectFit: 'contain',
                                backgroundColor: '#FFFFFF',
                            },
                        }}
                    />
                </ListItemAvatar>
                <Box display="flex" flexDirection="column" height="75px">
                    <ListItemText
                        primary={`${p.productName} ( x${p.productCount} )`}
                        primaryTypographyProps={{
                            variant: 'body2',
                            color: 'text.secondary',
                            fontWeight: 300,
                        }}
                        sx={{
                            margin: '0px',
                        }}
                    />
                    <Box
                        sx={{
                            height: '75px',
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            alignItems: 'flex-end',
                            margin: '0px',
                            gap: '4px',
                        }}
                    >
                        <Typography variant="body1bold" color="rgba(0, 0, 0)">
                            {Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'GBP',
                            }).format(p.productPrice)}
                        </Typography>
                        {showDiscount && (
                            <OriginalPrice.Component originalPrice={p.productOriginalPrice} />
                        )}
                    </Box>
                </Box>
            </ListItem>
        </>
    );
};

Component.displayName = 'BasketProduct';
